import { useState, type ReactNode } from 'react';
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Tabs, TabsList, TabsTrigger } from '@vnetwork/ui/primitives';
import { WaapConsoleBreadcrumbs } from '@/pages/services/waap/WaapConsoleBreadcrumbs';
import { MonitoringTab } from './MonitoringTab';
import { DeliveryOverviewTab } from './DeliveryOverviewTab';
import { SecurityOverviewTab } from './SecurityOverviewTab';
import { AiWafTab } from './AiWafTab';
import { BotManagementAnalyticsTab } from './BotManagementAnalyticsTab';
import { ApiAnalyticsTab } from './ApiAnalyticsTab';
import { ThreatInvestigationTab } from './ThreatInvestigationTab';

/**
 * WAAP Analytics — account-level, mirrors the vendor's 7-board Analytics. Each
 * sub-tab is a Superset board rendered as NATIVE charts (the BE pre-normalizes
 * the slices; no iframe embed).
 */
const TABS: { key: string; label: string; render: () => ReactNode }[] = [
  { key: 'monitoring', label: 'Monitoring', render: () => <MonitoringTab /> },
  { key: 'delivery', label: 'Delivery Overview', render: () => <DeliveryOverviewTab /> },
  { key: 'security', label: 'Security Overview', render: () => <SecurityOverviewTab /> },
  { key: 'aiwaf', label: 'AI-WAF', render: () => <AiWafTab /> },
  { key: 'bot', label: 'Bot Management', render: () => <BotManagementAnalyticsTab /> },
  { key: 'api', label: 'API', render: () => <ApiAnalyticsTab /> },
  { key: 'threat', label: 'Threat Investigation', render: () => <ThreatInvestigationTab /> },
];

export function AnalyticsTab() {
  const [active, setActive] = useState('monitoring');
  const current = TABS.find((t) => t.key === active) ?? TABS[0];

  return (
    <Container size="xl">
      <PageHeader breadcrumbs={<WaapConsoleBreadcrumbs trail={[{ label: 'Analytics' }]} />} title="Analytics" />

      <Tabs value={active} onValueChange={setActive} style={{ marginBottom: 'var(--vn-space-4)' }}>
        <TabsList>
          {TABS.map((t) => (
            <TabsTrigger key={t.key} value={t.key}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>

      {current.render()}
    </Container>
  );
}
